import o,{useEffect as A,useState as B}from"react";import{forwardRef as y,createElement as b}from"react";var h=a=>a.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),L=(...a)=>a.filter((e,u,r)=>!!e&&r.indexOf(e)===u).join(" ");import{forwardRef as q,createElement as P}from"react";var w={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var k=q(({color:a="currentColor",size:e=24,strokeWidth:u=2,absoluteStrokeWidth:r,className:c="",children:s,iconNode:I,...n},p)=>P("svg",{ref:p,...w,width:e,height:e,stroke:a,strokeWidth:r?Number(u)*24/Number(e):u,className:L("lucide",c),...n},[...I.map(([x,C])=>P(x,C)),...Array.isArray(s)?s:[s]]));var t=(a,e)=>{let u=y(({className:r,...c},s)=>b(k,{ref:s,iconNode:e,className:L(`lucide-${h(a)}`,r),...c}));return u.displayName=`${a}`,u};var d=t("CircleAlert",[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}],["line",{x1:"12",x2:"12",y1:"8",y2:"12",key:"1pkeuh"}],["line",{x1:"12",x2:"12.01",y1:"16",y2:"16",key:"4dfq90"}]]);var l=t("CircleCheckBig",[["path",{d:"M21.801 10A10 10 0 1 1 17 3.335",key:"yps3ct"}],["path",{d:"m9 11 3 3L22 4",key:"1pflzl"}]]);var i=t("Info",[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}],["path",{d:"M12 16v-4",key:"1dtifu"}],["path",{d:"M12 8h.01",key:"e9boi3"}]]);var f=t("TriangleAlert",[["path",{d:"m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",key:"wmoenq"}],["path",{d:"M12 9v4",key:"juzpu7"}],["path",{d:"M12 17h.01",key:"p32p05"}]]);var m=t("X",[["path",{d:"M18 6 6 18",key:"1bl5f8"}],["path",{d:"m6 6 12 12",key:"d8bk6v"}]]);var U={primary:"bg-black text-white border-black",secondary:"bg-gray-200 text-gray-700 border-gray-300",success:"bg-gray-100 text-gray-800 border-gray-200",warning:"bg-gray-300 text-gray-900 border-gray-400",error:"bg-gray-800 text-white border-gray-900"},O={small:"text-xs px-1.5 py-0.5 min-w-[1.25rem]",medium:"text-sm px-2 py-1 min-w-[1.5rem]",large:"text-base px-2.5 py-1.5 min-w-[1.75rem]"},H={circle:"rounded-full",rounded:"rounded-md",square:"rounded-none"},v={"top-right":"absolute top-0 right-0 -translate-y-1/2 translate-x-1/2","top-left":"absolute top-0 left-0 -translate-y-1/2 -translate-x-1/2","bottom-right":"absolute bottom-0 right-0 translate-y-1/2 translate-x-1/2","bottom-left":"absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/2",center:"relative"},G={primary:o.createElement(i,{size:12,"data-id":"element-47"}),secondary:o.createElement(i,{size:12,"data-id":"element-48"}),success:o.createElement(l,{size:12,"data-id":"element-49"}),warning:o.createElement(f,{size:12,"data-id":"element-50"}),error:o.createElement(d,{size:12,"data-id":"element-51"})},V=({children:a,variant:e="primary",size:u="medium",shape:r="rounded",position:c="center",style:s="filled",icon:I=!1,max:n=99,visible:p=!0,dismissible:x=!1,className:C="",onDismiss:F})=>{let[D,g]=B(p),[M,S]=B(a);if(A(()=>{g(p)},[p]),A(()=>{typeof a=="number"&&a>n?S(`${n}+`):S(a)},[a,n]),!D)return null;let R=`
    inline-flex items-center justify-center
    transition-all duration-200 ease-in-out
    ${s==="bordered"?"border-2":"border-0"}
    ${U[e]}
    ${O[u]}
    ${H[r]}
    ${v[c]}
    ${C}
  `,T=()=>{g(!1),F?.()};return o.createElement("span",{className:R,role:e==="primary"?"status":"badge","aria-label":`${e} badge`,"data-id":"element-52"},I&&o.createElement("span",{className:"mr-1","data-id":"element-53"},G[e]),M,x&&o.createElement("button",{onClick:T,className:"ml-1 hover:opacity-80 focus:outline-none","aria-label":"Dismiss badge","data-id":"element-54"},o.createElement(m,{size:12,"data-id":"element-55"})))};export{V as Badge};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/circle-alert.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/circle-check-big.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/info.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/triangle-alert.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/x.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
